import {message} from "antd";

class RouteManager {

    static URL_INDEX = "/";

    static URL_SEARCH = "/search";
    static URL_SEARCH_KEYWORD = "/search/:keyword";

    static URL_CATEGORY = "/category";

    static URL_ACHIEVE = "/achieve";
    static URL_ACHIEVE_CATEGORY_ID = "/achieve/:categoryId";
    static URL_ACHIEVE_CATEGORY_ID_TAG_ID = "/achieve/:categoryId/:tagId";

    static URL_ARTICLE = "/article";
    static URL_ARTICLE_ID = "/article/:id";

    static URL_REGISTER = "/register";

    static URL_LOGIN = "/login";

    static URL_RESET = "/reset";

    static URL_TEST = "/test";

    static URL_ADMIN = "/admin";

    static URL_ADMIN_DASHBOARD = "/admin/dashboard";

    static URL_ADMIN_USER = "/admin/user";
    static URL_ADMIN_USER_PERSONAL = "/admin/user/personal";
    static URL_ADMIN_USER_LIST = "/admin/user/list";

    static URL_ADMIN_ARTICLE = "/admin/article";
    static URL_ADMIN_ARTICLE_EDIT = "/admin/article/edit";
    static URL_ADMIN_ARTICLE_PREVIEW = "/admin/article/preview";
    static URL_ADMIN_ARTICLE_EDIT_ARTICLE_ID = "/admin/article/edit/:id";
    static URL_ADMIN_ARTICLE_LIST = "/admin/article/list";

    static URL_ADMIN_CATEGORY = "/admin/category";

    static URL_ADMIN_COMMENT = "/admin/comment";

    static URL_ADMIN_ATTACHMENT = "/admin/attachment";

    static URL_ADMIN_STATISTIC = "/admin/statistic";

    static URL_ADMIN_THEME = "/admin/theme";

    static URL_ADMIN_SETTING = "/admin/setting";

    static toLoginPage() {
        message.error("登录状态失效，即将跳转登录页面...");
        setTimeout(() => {
            window.location.href = RouteManager.URL_LOGIN;
        }, 1500);
    };
}

export default RouteManager;
